import * as React from "react";

const NoResultsImage = () => {
    return (
        <div className={'no-results-image'}><svg
            viewBox="0 0 200 155"
            xmlns="http://www.w3.org/2000/svg">
            <path
                className="cls-31"
                d="M 198.63,144.87 H 1.37 a 0.37,0.37 0 1 1 0,-0.74 h 197.26 a 0.37,0.37 0 0 1 0,0.74 z"
                id="path172-5"/>
            <g
                id="g1"
                transform="matrix(0.47819054,0,0,0.47819054,35.205182,73.832207)">
                <path
                    className="cls-4"
                    d="m 123.09916,125.25544 h -11.93 a 0.63,0.63 0 0 1 0,-1.26 h 11.93 a 0.63,0.63 0 1 1 0,1.26 z"
                    id="path12" />
                <g
                    className="cls-5"
                    id="g16"
                    transform="translate(-5.830839,-188.04456)">
                    <path
                        className="cls-4"
                        d="m 131.58,316 h -11.93 a 0.63,0.63 0 1 1 0,-1.26 h 11.93 a 0.63,0.63 0 0 1 0,1.26 z"
                        id="path14" />
                </g>
                <path
                    className="cls-6"
                    d="M 119.73916,147.07544 H 68.359161 a 1.61,1.61 0 0 1 -1.61,-1.61 V 40.285444 a 1.61,1.61 0 0 1 1.61,-1.61 H 206.93916 a 1.61,1.61 0 0 1 1.61,1.61 V 145.46544 a 1.61,1.61 0 0 1 -1.61,1.61 h -45.67"
                    id="path18" />
                <g
                    className="cls-7"
                    id="g24"
                    transform="translate(-5.830839,-188.04456)">
                    <path
                        className="cls-8"
                        d="m 186.49,331.52 h 21.71 a 1.61,1.61 0 0 0 1.61,-1.61 v -15.4"
                        id="path20" />
                    <line
                        className="cls-8"
                        x1="209.81"
                        y1="310.10001"
                        x2="209.81"
                        y2="307.57999"
                        id="line22" />
                </g>
                <g
                    className="cls-9"
                    id="g32"
                    transform="translate(-5.830839,-188.04456)">
                    <path
                        className="cls-8"
                        d="m 102.67,331.52 h -2.52"
                        id="path26" />
                    <path
                        className="cls-8"
                        d="M 97.14,331.52 H 81 a 1.61,1.61 0 0 1 -1.61,-1.61 v -6.08"
                        id="path28" />
                    <line
                        className="cls-8"
                        x1="79.349998"
                        y1="318.92001"
                        x2="79.349998"
                        y2="307.57999"
                        id="line30" />
                </g>
                <line
                    className="cls-10"
                    x1="185.64915"
                    y1="107.35544"
                    x2="185.64915"
                    y2="126.85545"
                    id="line34" />
                <path
                    className="cls-4"
                    d="m 185.64916,108.07544 h 3.28 a 0.22,0.22 0 0 0 0.19,-0.33 l -1.65,-2.79 -1.64,-2.84 a 0.22,0.22 0 0 0 -0.38,0 l -1.63,2.84 -1.65,2.79 a 0.22,0.22 0 0 0 0.19,0.33 z"
                    id="path36" />
                <line
                    className="cls-10"
                    x1="170.16916"
                    y1="107.35544"
                    x2="170.16916"
                    y2="126.85545"
                    id="line38" />
                <path
                    className="cls-4"
                    d="m 170.16916,108.07544 h 3.28 a 0.22,0.22 0 0 0 0.19,-0.33 l -1.64,-2.79 -1.64,-2.84 a 0.22,0.22 0 0 0 -0.38,0 l -1.64,2.84 -1.64,2.84 a 0.22,0.22 0 0 0 0.19,0.33 z"
                    id="path40" />
                <line
                    className="cls-10"
                    x1="165.00916"
                    y1="129.57544"
                    x2="190.80916"
                    y2="129.57544"
                    id="line42" />
                <g
                    className="cls-5"
                    id="g54"
                    transform="translate(-5.830839,-188.04456)">
                    <line
                        className="cls-10"
                        x1="193.2"
                        y1="298.16"
                        x2="193.2"
                        y2="317.66"
                        id="line44" />
                    <path
                        className="cls-4"
                        d="m 193.2,298.88 h 3.28 a 0.22,0.22 0 0 0 0.19,-0.33 l -1.67,-2.84 -1.64,-2.84 a 0.22,0.22 0 0 0 -0.38,0 l -1.64,2.84 -1.64,2.84 a 0.22,0.22 0 0 0 0.19,0.33 z"
                        id="path46" />
                    <line
                        className="cls-10"
                        x1="177.72"
                        y1="298.16"
                        x2="177.72"
                        y2="317.66"
                        id="line48" />
                    <path
                        className="cls-4"
                        d="M 177.72,298.88 H 181 a 0.22,0.22 0 0 0 0.19,-0.33 l -1.64,-2.84 -1.64,-2.84 a 0.22,0.22 0 0 0 -0.38,0 l -1.64,2.84 -1.64,2.84 a 0.22,0.22 0 0 0 0.19,0.33 z"
                        id="path50" />
                    <line
                        className="cls-10"
                        x1="172.56"
                        y1="320.38"
                        x2="198.36"
                        y2="320.38"
                        id="line52" />
                </g>
                <rect
                    className="cls-11"
                    x="79.919159"
                    y="101.45544"
                    width="56.09"
                    height="30.879999"
                    rx="2.55"
                    ry="2.55"
                    id="rect56" />
                <g
                    className="cls-12"
                    id="g60"
                    transform="translate(-5.830839,-188.04456)">
                    <rect
                        className="cls-11"
                        x="87.540001"
                        y="290.56"
                        width="56.09"
                        height="30.879999"
                        rx="2.55"
                        ry="2.55"
                        id="rect58" />
                </g>
                <path
                    className="cls-4"
                    d="M 116.91916,109.21544 H 83.099161 a 0.63,0.63 0 1 1 0,-1.26 h 33.819999 a 0.63,0.63 0 1 1 0,1.26 z"
                    id="path62" />
                <path
                    className="cls-4"
                    d="M 130.81916,116.51544 H 83.099161 a 0.63,0.63 0 1 1 0,-1.26 h 47.729999 a 0.63,0.63 0 1 1 0,1.26 z"
                    id="path64" />
                <path
                    className="cls-4"
                    d="M 106.95916,123.80544 H 83.099161 a 0.63,0.63 0 1 1 0,-1.26 h 23.859999 a 0.63,0.63 0 1 1 0,1.26 z"
                    id="path66" />
                <path
                    className="cls-4"
                    d="m 125.51916,123.80544 h -11.93 a 0.63,0.63 0 1 1 0,-1.26 h 11.93 a 0.63,0.63 0 0 1 0,1.26 z"
                    id="path68" />
                <g
                    className="cls-13"
                    id="g78"
                    transform="translate(-5.830839,-188.04456)">
                    <line
                        className="cls-14"
                        x1="91.580002"
                        y1="299.29001"
                        x2="125.4"
                        y2="299.29001"
                        id="line70" />
                    <line
                        className="cls-14"
                        x1="91.580002"
                        y1="306.57999"
                        x2="139.3"
                        y2="306.57999"
                        id="line72" />
                    <line
                        className="cls-14"
                        x1="91.580002"
                        y1="313.87"
                        x2="115.44"
                        y2="313.87"
                        id="line74" />
                    <line
                        className="cls-14"
                        x1="122.07"
                        y1="313.87"
                        x2="134"
                        y2="313.87"
                        id="line76" />
                </g>
                <path
                    className="cls-6"
                    d="m 221.99916,83.405444 -168.889999,-0.72 a 1.33,1.33 0 0 1 -1.25,-1.73 l 15,-42.4 140.919999,0.6 15.49,42.53 a 1.33,1.33 0 0 1 -1.27,1.72 z"
                    id="path80" />
                <path
                    className="cls-15"
                    d="m 67.369161,37.085444 -28.46,27.62 a 0.17,0.17 0 0 1 -0.26,-0.21 l 20.9,-32.61 28.62,-27.7699999 a 0.1421267,0.1421267 0 0 1 0.22,0.18 z"
                    id="path82" />
                <path
                    className="cls-15"
                    d="m 207.08916,37.085444 28.45,27.62 a 0.17,0.17 0 0 0 0.26,-0.21 l -20.9,-32.61 -28.61,-27.7699999 a 0.1421267,0.1421267 0 0 0 -0.22,0.18 z"
                    id="path84" />
                <rect
                    className="cls-15"
                    x="89.049156"
                    y="4.075439"
                    width="96.260002"
                    height="34.689999"
                    id="rect86" />
                <polygon
                    className="cls-16"
                    points="191.13,226.86 191.13,192.18 213.68,226.86 "
                    id="polygon88"
                    transform="translate(-5.830839,-188.04456)" />
                <polygon
                    className="cls-16"
                    points="73.2,226.86 94.01,192.18 94.01,226.86 "
                    id="polygon90"
                    transform="translate(-5.830839,-188.04456)" />
                <line
                    className="cls-17"
                    x1="66.499161"
                    y1="85.975433"
                    x2="208.61916"
                    y2="85.975433"
                    id="line92" />
                <path
                    className="cls-18"
                    d="m 153.09916,147.07544 h -8.13"
                    id="path94" />
                <path
                    className="cls-18"
                    d="m 140.24916,147.07544 h -18.41"
                    id="path96" />
                <path
                    className="cls-18"
                    d="M 117.16916,147.07544 H 65.759161 a 1.61,1.61 0 0 1 -1.59,-1.61 V 83.465444"
                    id="path98" />
                <path
                    className="cls-18"
                    d="M 65.759161,38.675444 H 204.33916"
                    id="path100" />
                <path
                    className="cls-18"
                    d="m 205.94916,83.425444 v 61.999996 a 1.61,1.61 0 0 1 -1.61,1.61 h -45.68"
                    id="path102" />
                <path
                    className="cls-18"
                    d="m 83.339161,38.675444 h 7.83"
                    id="path104" />
                <path
                    className="cls-18"
                    d="M 219.49916,83.045444 H 50.599161 a 1.33,1.33 0 0 1 -1.25,-1.77 l 14.82,-42.46 H 205.06916 l 15.68,42.46 a 1.33,1.33 0 0 1 -1.25,1.77 z"
                    id="path106" />
                <path
                    className="cls-18"
                    d="m 64.759161,37.085444 -28.45,27.62 a 0.17,0.17 0 0 1 -0.26,-0.21 l 20.9,-32.61 28.62,-27.7699999 a 0.1421267,0.1421267 0 0 1 0.22,0.18 z"
                    id="path108" />
                <path
                    className="cls-18"
                    d="m 204.48916,37.085444 28.45,27.62 a 0.17,0.17 0 0 0 0.26,-0.21 l -20.9,-32.61 -28.61,-27.7699999 a 0.1421267,0.1421267 0 0 0 -0.22,0.18 z"
                    id="path110" />
                <rect
                    className="cls-18"
                    x="86.439156"
                    y="4.075439"
                    width="96.260002"
                    height="34.689999"
                    id="rect112" />
            </g>
        </svg>


        </div>
    )
}

export { NoResultsImage }
